import { useDispatch } from "react-redux";
import { useGetTotalUnreadMessageMutation} from "../../../Store/Builder/messaging.api";
import showToast from "../../Hooks/toast";
import {setTotalUnreadMessage} from "../../../Store/Slice/messagingSlice";

const useGetTotalUnreadMessage = () => {
  const dispatch = useDispatch();
  const [getTotalUnreadMessage] = useGetTotalUnreadMessageMutation();

  const get = () => {
    getTotalUnreadMessage()
      .unwrap()
      .then((res) => {
        dispatch(setTotalUnreadMessage(res.total))
      })
      .catch((err) => {
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetTotalUnreadMessage;
